export default __webpack_public_path__ + "box-face-fix.jpg";